<template>
    <div>
        <van-cell-group class="hasradius">
            <van-field  class="note-code"
                    v-model="sms"
                    required
                    center
                    clearable
                    label="短信验证码"
                    placeholder="请输入短信验证码"
            >
                <van-button slot="button" round type="info"  @click="sendSms"   size="mini" :disabled="disabledStatus">{{text}}</van-button>
            </van-field>
        </van-cell-group>
        <!--已被注册的提示框-->
        <van-dialog class="zhuced"
                    v-model="showNotePops"
                    @cancel="cancelLoading"
                    @confirm="confirmAppeal"
                    show-confirm-button confirm-button-text="申诉"
                    show-cancel-button  cancel-button-text="登录"
        >
            <div class="contentbox">
                <img class="ybzc-img" src="~@public/img/signup/zbzc_icon.png">
                <p>该手机号已被注册，</p>
                <p>如有疑问请进行申诉操作</p>
            </div>

        </van-dialog>
    </div>
</template>

<script>
    import { CellGroup, Field,Button,Toast,Dialog} from 'vant'
    import {checkPhoneNum} from '@assets/js/api/Regular'
    import {memberApi} from '@/api/member'

    export default {
        name: "NoteCode",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Button.name]: Button,
            [Toast.name]: Button,
            [Dialog.Component.name]:Dialog.Component,
        },
        props: {
            receivePhone: {
                type: String,
                default: ''
            },
            member:{
                type:Object,
                default: ()=>{
                }
            },
            VerificationStatus:{
                type:Object,
                default: ()=>{}
            },
            source:{
                type:String,
                default:''
            }
        },
        data(){
            return{
                showNotePops:false,
                sms:'',
                text:"获取验证码",
                disabledStatus: false, // 控制返送短信验证码按钮是否可以点击状态
                countDown: null,
                second: 60,
            }
        },
        watch:{
            second(val) {
                if (val <= -1) {
                    this.initializationCountDown()
                    this.$parent.getNewPic()
                }
            },
        },
        mounted(){
            Toast.setDefaultOptions({ duration: 1500 });
        },
        methods:{
            /**
             * 发送短信
             */
            async sendSms() {
                if (!this.receivePhone) {
                    Toast('请输入的手机号码')
                    return ;
                } else if (!checkPhoneNum(this.receivePhone)&&this.source!=="forget") {
                    Toast('请输入正确的手机号码')
                    return ;
                }
                else {
                    this.countDownStart()
                    if(this.source==='appeal'){
                        try{
                            let data = {
                                mobilePhone: this.receivePhone,
                                verificationCode: this.VerificationStatus.verificationCode,
                                verificationCodeGuid: this.VerificationStatus.verificationCodeGuid
                            }
                            const res = await this.$httpUtils.postCommonUtils(memberApi.memberTelAppealThir, data)
                            if (res.data.succ) {
                                Toast.success('短信发送成功')
                            } else {
                                this.interactionVerificationCode()
                                if(res.data.status === 2){
                                    Toast.fail('该账号不存在。')
                                    this.initializationCountDown()
                                }else{
                                    Toast.fail('短信发送失败，请重试')
                                    this.initializationCountDown()
                                }
                            }
                        }catch (e) {
                            Toast.fail('服务器运行失败，请稍后再试。')
                            console.log(error)
                        }
                        return ;
                    }else if(this.source==='appealCard'){
                        try{
                            let data = {
                                mobilePhone: this.receivePhone,
                                verificationCode: this.VerificationStatus.verificationCode,
                                verificationCodeGuid: this.VerificationStatus.verificationCodeGuid
                            }
                            const res = await this.$httpUtils.postCommonUtils(memberApi.memberAppealThir, data)
                            if (res.data.succ) {
                                Toast.success('短信发送成功')
                            } else {
                                this.interactionVerificationCode()
                                if(res.data.status === 2){
                                    Toast.fail('该账号不存在。')
                                    this.initializationCountDown()
                                }else{
                                    Toast.fail('短信发送失败，请重试')
                                    this.initializationCountDown()
                                }
                            }
                        }catch (e) {
                            Toast.fail('服务器运行失败，请稍后再试。')
                            console.log(error)
                        }
                        return ;
                    }else if(this.source==='blackListSms'){
                        try{
                            if (this.VerificationStatus.verificationCode==undefined) {
                                Toast('请输入图形验证码')
                                this.initializationCountDown()
                                return ;
                            } else if (!this.VerificationStatus.IsInputSuccStatus) {
                                Toast('请输入正确的图形验证码')
                                this.initializationCountDown()
                                return ;
                            }
                            let data = {
                                mobilePhone: this.receivePhone,
                                verificationCode: this.VerificationStatus.verificationCode,
                                verificationCodeGuid: this.VerificationStatus.verificationCodeGuid
                            }
                            const res = await this.$httpUtils.postCommonUtils(memberApi.memberAuthBlackSms, data)
                            if (res.data.succ) {
                                Toast.success('短信发送成功')
                            } else {
                                this.interactionVerificationCode()
                                if(res.data.status === 2){
                                    Toast.fail('该账号不存在。')
                                    this.initializationCountDown()
                                }else{
                                    Toast.fail('短信发送失败，请重试')
                                    this.initializationCountDown()
                                }
                            }
                        }catch (e) {
                            Toast.fail('服务功能不稳定，请稍后再试或前往鄂汇办APP进行账号登陆后进行二次核验！！！')
                            this.initializationCountDown()
                            console.log(error)
                        }
                        return ;
                    }else if(this.source==='forget'){
                        try{
                            if (this.VerificationStatus.verificationCode==undefined) {
                                Toast('请输入图形验证码')
                                this.initializationCountDown()
                                return ;
                            } else if (!this.VerificationStatus.IsInputSuccStatus) {
                                Toast('请输入正确的图形验证码')
                                this.initializationCountDown()
                                return ;
                            }
                            let data = {
                                idCard:this.member.idCard,
                                verificationCode: this.VerificationStatus.verificationCode,
                                verificationCodeGuid: this.VerificationStatus.verificationCodeGuid
                            }
                            const res = await this.$httpUtils.postCommonUtils(memberApi.findPsdNew2, data)
                            if (res.data.succ) {
                                Toast.success('短信发送成功')
                            } else {
                                this.interactionVerificationCode()
                                Toast.fail('短信发送异常')
                            }
                        }catch (e) {
                            Toast.fail('服务器运行失败，请稍后再试。')
                            console.log("forget:"+e)
                        }
                    }else{
                        try {
                            if (this.VerificationStatus.verificationCode==undefined) {
                                    Toast('请输入图形验证码')
                                this.initializationCountDown()
                                    return ;
                                } else if (!this.VerificationStatus.IsInputSuccStatus) {
                                    Toast('请输入正确的图形验证码')
                                this.initializationCountDown()
                                    return ;
                                }
                            let data = {
                                name:this.member.userName,
                                idCard:this.member.idCard,
                                mobilePhone: this.receivePhone,
                                verificationCode: this.VerificationStatus.verificationCode,
                                verificationCodeGuid: this.VerificationStatus.verificationCodeGuid
                                // verificationCode: "",
                                // verificationCodeGuid: ""
                            }
                            const res = await this.$httpUtils.postCommonUtils(memberApi.memberSms, data)
                            if (res.data.succ) {
                                Toast.success('短信发送成功')
                            } else {
                                // this.interactionVerificationCode()
                                if(res.data.status === 211003){
                                    Toast.fail('图形验证码已失效，请重新获取。')
                                    this.initializationCountDown()
                                }else if(res.data.status === -1){
                                    Toast.fail('网络异常，请重试。')
                                    this.initializationCountDown()
                                }else if(res.data.status === 3){
                                    Toast.fail('短息发送失败。')
                                    this.initializationCountDown()
                                }else if(res.data.status === 2){
                                    this.showNotePops=true
                                    // Toast.fail('该手机号已被他人身份证号注册，前往申诉。')
                                    this.initializationCountDown()
                                }else{
                                    Toast.fail(res.data.msg)
                                    this.initializationCountDown()
                                }
                            }
                        } catch (error) {
                            Toast.fail('服务器运行失败，请稍后再试。')
                            this.initializationCountDown()
                            console.log(error)
                        }
                    }

                }
            },
            /**
             * 发送短信定时器
             */
            countDownStart() {
                this.disabledStatus = true
                this.countDown = setInterval(() => {
                    this.text = `${this.second}秒后重新发送`
                    this.second--
                }, 1000)
            },
            /**
             * 短信发送验证码校验失败时发送短信定时器初始化
             */
            initializationCountDown() {
                clearInterval(this.countDown)
                this.text = '发送验证码'
                this.disabledStatus = false
                this.second = 60
            },
            /**
             * 发送短信定时器初始化(给父组件调用)，方法中多一个清除sms值对步骤
             */
            initializationCountDownParent() {
                clearInterval(this.countDown)
                this.text = '发送验证码'
                this.disabledStatus = false
                this.second = 60
                this.sms = ''
            },
            /**
             * 图形验证码和短信验证码传值给父组件
             */
            passValue() {
                this.$emit('setVerification', this.sms)
            },
            /**
             * 手机号被注册弹框——登陆
             */
            cancelLoading(){
                this.$router.push("/sign-up/login")
                this.showNotePops = false
            },
            /**
             * 手机号被注册弹框----申诉
             */
            confirmAppeal(){
                this.$router.push("/sign-up/account-appeal")
                this.showNotePops = false
            }
        }
    }
</script>

<style scoped>
.note-code button{background: #0687f8;color: #fff;height: 0.77rem;padding: 0 10px;line-height: 0.77rem}
.zhuced{font-size: 30px;color: #000;}
.bluetext{color: #2664AD;font-weight: 700;font-size: 32px;padding-top: 5px}
.contentbox{width: 100%;padding: 50px 0 30px 0;display: flex;flex-wrap: wrap;justify-content: center;align-items: center}
.contentbox p{width: 100%;text-align: center;}
</style>
<style>
    .hasradius{border-radius:0.6rem;}
</style>
